import { Injectable, Component, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs/Rx';
import { Http, Response, RequestOptions, Headers, RequestOptionsArgs } from '@angular/http';
import { appFeatures } from './models/appFeatures'
import * as _ from 'lodash';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SlideshowModule } from 'ng-simple-slideshow';
import { Constants } from './models/constants';

@Injectable()
export class LoginObservableService {

    private userAppFeatures;
    LocalFeaturesJson;
    private isUserHasLoggedIn = new BehaviorSubject<String>('false');
    cast = this.isUserHasLoggedIn.asObservable();
    constructor(private http: Http, public dialog: MatDialog) {
        this.LocalFeaturesJson = appFeatures;
        this.loadDefaultAppFeatures();
    }

    loginChanged(data) {
        if (this.isUserHasLoggedIn['_value'] != data) {
            this.isUserHasLoggedIn.next(data);
        }
        if (data != 'false' && data != false) {
            this.loadUserAppFeatures();
        } else {
            this.loadDefaultAppFeatures();
        }
    }


    loadUserAppFeatures() {
        var self = this;
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.userToken);
        const options = new RequestOptions({ headers: headers });
        this.http.post(
            "http://" + Constants.nasUrl, {
                "query": 'query{appPremissions{directExport, organizationId, appFeatures{id, featuresType, name, code}contacts{user{id, name, type, email}}}}'
            }, options
        ).subscribe(
            res => {
                self.userAppFeatures = res.json().data.appPremissions.appFeatures;

                localStorage.contacts = JSON.stringify(res.json().data.appPremissions.contacts);

            }
        );
    }

    loadDefaultAppFeatures() {
        var self = this;
        this.http.post(
            "http://" + Constants.nasUrl, {
                "query": 'query{DefaultappFeatureGroups{features{id, featuresType, name, code}}}'
            }
        ).subscribe(
            res => {
                self.userAppFeatures = res.json().data.DefaultappFeatureGroups[0].features;
            }
        );
    }

    getAppFeatures() {
        return this.userAppFeatures;
    }

    isThisFeatureIsAvailable(optName) {
        var featureCode = this.LocalFeaturesJson[optName];
        if (featureCode) {
            if (this.userAppFeatures) {
                var isFeatureAccessable = _.filter(this.userAppFeatures, function (filter) { return filter.code == featureCode });
                if (isFeatureAccessable.length) {
                    return 'true';
                } else {
                    return 'false';
                }
            }
        } else {
            return 'true'
        }
    }

    openSubscribenowPopup() {
        let dialogRef = this.dialog.open(subscribenowPopup, {
            width: '500px',
            disableClose: false
        });

        dialogRef.afterClosed().subscribe(result => {

        })
    }


}


// subscribe now folder popup
@Component({
    selector: 'app-subscribenow',
    templateUrl: './subscribenow.popup.html',
    styleUrls: ['./css/common.css']
})
export class subscribenowPopup {
    imageSources = ['assets/images/nplus1.jpg', 'assets/images/nplus2.jpg', 'assets/images/nplus3.jpg', 'assets/images/nplus4.jpg']
    constructor(
        public dialogRef: MatDialogRef<subscribenowPopup>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onYesClick(data) {
        this.dialogRef.close(data);
    }


}
  // subscribe now popup end



// WEBPACK FOOTER //
// ./src/app/shared/loginObservable.service.ts